export default __webpack_public_path__ + "static/media/image-board-study-now-n-m.065d6d6a.webp";